import { render } from "./add-admin.vue?vue&type=template&id=4643a018&scoped=true"
import script from "./add-admin.vue?vue&type=script&lang=js"
export * from "./add-admin.vue?vue&type=script&lang=js"

import "./add-admin.vue?vue&type=style&index=0&id=4643a018&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4643a018"]])

export default __exports__